import { formatRFC3339 } from 'date-fns';

import { HttpParameterCodec } from '@angular/common/http';

import { isMatSort } from './is-mat-sort';
import { matSortTransformer } from './mat-sort-transformer';

class SnHttpParameterCodec implements HttpParameterCodec {
  public encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  public encodeValue(value: string): string {
    if ([undefined, 'null', 'undefined'].includes(value)) {
      return;
    }

    const dateRegex =
      /^[A-Z][a-z]{2}\s[A-Z][a-z]{2}\s\d{2}\s\d{4}\s\d{2}:\d{2}:\d{2}\sGMT[+-]\d{4}\s\(.+\)$/;

    if (dateRegex.test(value)) {
      value = formatRFC3339(new Date(value));
    } else if (isMatSort(value)) {
      value = matSortTransformer(value);
    }

    return encodeURIComponent(value);
  }

  public decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  public decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

export const SN_HTTP_PARAMETER_CODEC = new SnHttpParameterCodec();
